
import 'vue-range-component-fixed/dist/vue-range-slider.css';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { convertorNumberCircumcision } from '~/helpers/convertor';

export default {
  name: 'Vrage',
  emits: ['changePrice'],
  data() {
    const currencyMask = createNumberMask({
      prefix: '',
      allowDecimal: true,
      allowNegative: true,
      thousandsSeparatorSymbol: ' ',
      decimalLimit: 2,
    });

    return {
      valueMin: '',
      valueMax: '',

      minimal: null,
      maximal: null,

      timeOutChange: null,
      timeOutInputChange: null,
      timeOutInputMinChange: null,
      timeOutInputMaxChange: null,

      range: [0, 0],

      currencyMask,

      timeOutSetActiveFilter: null,

      isInit: false,
    };
  },
  components: {},

  props: {
    filterPrices: {
      type: Object,
      default() {
        return {};
      },
    },
    minPrice: {
      type: Number,
      default: 0,
    },

    maxPrice: {
      type: Number,
      default: 0,
    },

    selectedFilters: {
      type: Object,
      default: () => ({}),
    },

    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    filter() {
      const minVariant = Number(this?.minPrice) || 0;
      const maxVariant = Number(this?.maxPrice) || 0;

      if (!!this.isInit && (minVariant === this.minimal && maxVariant === this.maximal)) {
        return;
      }

      this.initFilter();
    },
    selectedFilters(current, prev) {
      const valueCurrentPriceFrom = JSON.stringify(current?.priceFrom);
      const valuePrePriceFrom = JSON.stringify(prev?.priceFrom);

      const valueCurrentPriceTo = JSON.stringify(current?.priceTo);
      const valuePrePriceTo = JSON.stringify(prev?.priceTo);

      if ((valueCurrentPriceFrom !== valuePrePriceFrom) || (valueCurrentPriceTo !== valuePrePriceTo)) {
        this.initFilter();
      }
    },

    range() {
      if (!this.isInit) {
        return;
      }

      this.valueMin = String(convertorNumberCircumcision(this.range?.[0], 2, '.'));
      this.valueMax = String(convertorNumberCircumcision(this.range?.[1], 2, '.'));
    },

  },

  methods: {
    // Инициализация фильтра
    initFilter() {
      if (this.minPrice === 'undefined' || this.maxPrice === 'undefined') {
        this.isInit = false;
        this.valueMin = '';
        this.valueMax = '';

        return;
      }

      const minVariant = Number(this?.minPrice) || 0;
      const maxVariant = Number(this?.maxPrice) || 0;

      this.minimal = minVariant;
      this.maximal = maxVariant;

      const selectedValuePriceFrom = (this.selectedFilters?.priceFrom);
      const selectedValuePriceTo = this.selectedFilters?.priceTo;

      const isFilterSelected = Boolean(selectedValuePriceFrom) && Boolean(selectedValuePriceTo);

      const selectedValue = isFilterSelected
        ? [Object.keys(selectedValuePriceFrom)?.[0], Object.keys(selectedValuePriceTo)?.[0]].join(':')
        : [minVariant, maxVariant].join(':');

      this.range = selectedValue.split(':').map((t) => Number.parseFloat(t));
      this.isInit = true;
    },

    // Логика работы по изменения
    changeInputMinimal({ target }) {
      let { value } = target;
      if (value === 'undefined' || value === '') {
        return;
      }
      const newValue = this.replaceSpacingString(value);

      value = Number.parseFloat(newValue || this.minPrice);

      if (value < this.minPrice) {
        value = this.minPrice;
      }

      if (value > this.range?.[1]) {
        value = this.range?.[1];
      }

      const range = [...this.range];
      range[0] = value;
      this.range = range;

      this.changeRange();
    },

    changeInputMaximal({ target }) {
      let { value } = target;
      if (value === 'undefined' || value === '') {
        return;
      }
      const newValue = this.replaceSpacingString(value);

      value = Number.parseFloat(newValue || this.maxPrice);
      if (value > this.maxPrice) {
        value = this.maxPrice;
      }
      if (value < this.range?.[0]) {
        value = this.range?.[0];
      }

      const range = [...this.range];
      range[1] = value;
      this.range = range;

      this.changeRange();
    },

    changeRange() {
      this.setNewFilter();
    },

    changeMinInput(value) {
      this.changeInputMinimal(value);
    },

    changeMaxInput(value) {
      this.changeInputMaximal(value);
    },

    // Убрать лишние пробелы в строке
    replaceSpacingString(string = '') {
      return string.replace(/\s/g, '');
    },

    // Логика по установке фильтра
    setNewFilter() {
      const range = [...this.range];
      range[0] = convertorNumberCircumcision(range[0], 2, '.');
      range[1] = convertorNumberCircumcision(range[1], 2, '.');

      const minPrice = range[0];
      const maxPrice = range[1];

      this.$emit('changePrice', { minPrice, maxPrice });
    },

    setFocusInput(refKey) {
      this.$refs[refKey].select();
    },
  },

  mounted() {
    this.initFilter();
  },
};
